/**
 * The ID of a User (e.g. joe@test.3s5j.att.com)
 * @public
 * @static
 * @typedef {string} UserID
 * @memberof user
 * @requires cpaas_user_id
 */

/**
 * The User ID ie: joe@test.3s5j.att.com
 *
 * @public
 * @static
 * @typedef {string} UserID
 * @memberof call
 * @requires cpaas_user_id
 */

/**
 * The ID of a User (e.g. joe@domain.com)
 * @public
 * @static
 * @typedef {string} UserID
 * @memberof user
 * @requires link_user_id
 */

/**
 * The SIP URI ie: sip:joe@domain.com
 *
 * @public
 * @static
 * @typedef {string} SIP_URI
 * @memberof call
 * @requires link_user_id
 */

/**
 * The Phone Number ie: +18885559876
 *
 * @public
 * @static
 * @typedef {string} PhoneNumber
 * @memberof call
 * @requires cpaas_pstn
 */

/**
 * The TEL URI ie: tel:+18885559876
 *
 * @public
 * @static
 * @typedef {string} TEL_URI
 * @memberof call
 * @requires link_pstn
 */
